import { Styles, generateClasses } from 'netline-ui';

export const moduleVersionClasses = generateClasses('ModuleVersion', [
  'row',
  'appNameColumn',
  'content',
  'activeModule',
  'mainModuleName',
  'mainModuleVersion',
  'subModuleName',
  'subModuleVersion',
] as const);

const styles: Styles = ({ theme: { palette, spacing } }) => ({
  [`.${moduleVersionClasses.row}`]: {
    display: 'flex',
  },

  [`.${moduleVersionClasses.appNameColumn}`]: {
    marginRight: spacing(1),
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    overflow: 'hidden',
    maxWidth: 300,
  },

  [`.${moduleVersionClasses.activeModule}`]: {
    fontWeight: '900 !important',
  },

  [`.${moduleVersionClasses.mainModuleName},.${moduleVersionClasses.mainModuleVersion}`]: {
    fontWeight: 500,
    letterSpacing: 1,
  },

  [`.${moduleVersionClasses.subModuleName},.${moduleVersionClasses.subModuleVersion}`]: {
    fontWeight: 400,
    letterSpacing: 0.5,
    color: palette.grey[600],
  },
  [`.${moduleVersionClasses.content}`]: {
    marginBottom: spacing(1.5),
  },
});

export default styles;
